<script>
  import {Component, Prop, Vue} from "vue-property-decorator";

  @Component({
    components: {}
  })
  export default class PrintHead extends Vue {
    @Prop({
      type: Object, default: () => {
      }
    }) info;


    get gridStyle() {
      return {
        'display': 'grid',
        'grid-template-columns': `30% auto `,
        'grid-template-rows': 'minmax(36px, auto)',
        'gridGap': '12px',
        'justify-content': 'space-around'
      }
    }

    mounted() {
    }

    render(h) {
      const {gridStyle} = this
      return (
        <div class="print-head">
          <div style="border-bottom: 1px solid #000;">
            <img src="/static/resources/img/SIXTY.png"/>
          </div>
          <div class="print-title">
            <p class="title">服装产品采购订单</p>
            <p>Apparel Product Purchase Order(“order “or “agreement”)</p>
          </div>
          <div class="print-head-main">
            <div>
              <div><span class="bold">Buyer: Sixty Asia Investments Limited</span>（“SIXTY”）</div>
              <div>Contact Address: at 1106C, 11/F, 133 Wai Yip Street, Kwun Tong, Kowloon, Hong Kong  </div>
              <div style="margin-top: 30px;" class="bold">产品、货期及付款信息/Product, Delivery and Payment</div>
            </div>
            <div>
              <div><span class="bold">Supplier：{this.info.vendorName}</span>(“Supplier”)</div>
              <div>Contact Address ：{this.info.vendorAddress}</div>
            </div>
          </div>
        </div>

      );
    }
  }
</script>

<style scoped lang="scss">
  .print-head{
    font-size: 12px;
    font-family: SimSun;
  }
  .print-head-main {
    display: flex;
    justify-content: flex-start;
  }
  .print-head-main > div:nth-child(1) {
    margin-right: 100px;
  } 
  .print-head-main > div div {
    margin-bottom: 10px;
  }
  .print-title {
    margin-bottom: 30px;
  }
  .print-title p {
    text-align: center;
  }
  .print-title .title {
    font-size: 16px;
    font-weight: bold;
  }
  .bold {
    font-weight: bold !important;
  }
</style>